import { render } from "./WizardStep3.pug?vue&type=template&id=67c39ddb&lang=pug"
import script from "./WizardStep3.js?vue&type=script&lang=js"
export * from "./WizardStep3.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__